// extracted by mini-css-extract-plugin
export default {"ubuntuContent":"ubuntu_ubuntuContent__oKjdr","imageContainer":"ubuntu_imageContainer__Py9w2","contact":"ubuntu_contact__8YWnp","contactIcon":"ubuntu_contactIcon__m7ZAW"};